import { useTranslations } from '~/src/hooks/useTranslations'
import { Box, Button, Divider, Typography, useTheme } from '@mui/material'
import ResponsiveDialog from '~/src/components/mui-wrappers/responsive-dialog'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'
import CssUtils from '~/src/utils/CssUtils'
import { Player } from '@lottiefiles/react-lottie-player'
import AuthenticationDialogTitle from '~/src/components/auth/dialogs/AuthenticationDialogTitle'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'

const RegisterSuccessfulDialog = () => {
  const { t } = useTranslations()
  const theme = useTheme()
  const { next } = useAuthenticationFlowDialogs()

  return (
    <ResponsiveDialog
      openByDefault
      showCloseButton
      name={AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_SUCCESSFUL}
      Title={<AuthenticationDialogTitle>{t('auth.registerSuccessful.dialog.title')}</AuthenticationDialogTitle>}
      titleSx={{
        px: `${theme.spacing(2)} !important`,
        gap: 1
      }}
      contentSx={{
        px: 3
      }}>
      <Typography
        variant='h6'
        sx={{
          fontSize: 'min(max(1rem, 4vw), 1.25rem)'
        }}>
        {t('auth.registerSuccessful.dialog.subTitle')}
      </Typography>

      <Player
        src='/images/lotties/validated.json'
        autoplay
        keepLastFrame
        style={{
          width: '60%'
        }}
      />

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center'
      }}>
        <Divider
          sx={{
            width: '80%',
            borderColor: CssUtils.addTransparencyToHexColor(theme.palette.primary.main, 20)
          }}/>

        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Button
            variant='contained'
            color='primary'
            onClick={next}>
            {t('auth.registerSuccessful.dialog.cta')}
          </Button>
        </Box>
      </Box>
    </ResponsiveDialog>
  )
}

export default RegisterSuccessfulDialog
